import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _URLSearchParams from "@babel/runtime-corejs3/core-js/url-search-params";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMixin } from "vuelidate";
import { required, requiredIf, email } from "vuelidate/lib/validators";
import { CREATE_NEW_LIST, RESET_CURRENT_LIST, LOAD_CURRENT_LIST, UPDATE_LIST, DELETE_CURRENT_LIST, EXPORT_LIST_CONTACTS, DELETE_ALL_LIST_CONTACTS, UPDATE_CURRENT_LIST } from "../../store/marketing/marketing-actions";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { mapActions } from "vuex";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MarketingListDetails from "./marketing-list-details.vue";
import MarketingListHeader from "./headers/marketing-list-header.vue";
import ListDetailsLoader from "./list-details-loader.vue";
import { showToast } from "@Shared/utils/constants";
import Err from "@Broker/@Routes/error";
import { every, mapValues, pick } from "lodash";
import { anyRequired } from "@Shared/@Utils/validation-rules";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingListAddContainer",
  title() {
    return this.$t("sidebar.sections.marketingLists");
  },
  components: {
    MarketingListDetails,
    MarketingListHeader,
    ListDetailsLoader,
    SimpleButton
  },
  mixins: [validationMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => vm.RESET_CURRENT_LIST());
  },
  props: {
    creating: {
      type: Boolean,
      default: true
    },
    listId: {
      type: [String, Number],
      default: null
    },
    addingContacts: {
      type: String,
      default: null
    },
    backPath: {
      type: String,
      default: "/marketing/lists"
    }
  },
  validations() {
    var _this$currentList$csv, _this$currentList$csv2, _this$currentList$csv3;
    const validationObject = {
      name: {
        required
      },
      description: {
        required
      },
      manually: {
        required
      },
      importedList: {
        required: requiredIf(currentList => currentList.manually),
        $each: this.currentList.manually ? {
          required,
          email
        } : {}
      },
      clientProfiles: {
        required: anyRequired([this.currentList.manually, this.currentList.applications, this.currentList.referrerList, ((_this$currentList$csv = this.currentList.csvArray) == null ? void 0 : _this$currentList$csv.length) > 0], value => {
          return value === true;
        })
      },
      applications: {
        required: anyRequired([this.currentList.manually, this.currentList.clientProfiles, this.currentList.referrerList, ((_this$currentList$csv2 = this.currentList.csvArray) == null ? void 0 : _this$currentList$csv2.length) > 0], value => {
          return value === true;
        })
      },
      referrerList: {
        required: anyRequired([this.currentList.manually, this.currentList.applications, this.currentList.clientProfiles, ((_this$currentList$csv3 = this.currentList.csvArray) == null ? void 0 : _this$currentList$csv3.length) > 0], value => {
          return value === true;
        })
      }
    };
    if (this.viewingDetails) return {
      currentList: pick(validationObject, ["name", "description", "address"])
    };
    return {
      currentList: validationObject
    };
  },
  data() {
    return {
      loading: false,
      fieldsVisibility: {
        name: true,
        description: true,
        address: true
      },
      importContacts: this.creating,
      deletingList: {
        loading: false,
        status: true
      },
      creatingList: {
        loading: false,
        status: true
      },
      updatingList: {
        loading: false,
        status: true
      },
      deletingAllContacts: {
        loading: false,
        status: true
      },
      listToEdit: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapFields("MarketingStore", ["currentList"])), {}, {
    manually: {
      get() {
        return this.currentList.manually;
      },
      set(value) {
        this.UPDATE_CURRENT_LIST(_objectSpread(_objectSpread({}, this.currentList), {}, {
          manually: value
        }));
      }
    },
    //TODO: [alexis] quick fix to make my life easy for the validation
    // but fieldsVisibility is not doing anything since all
    // the values are always the same value -- needs refactor
    viewingDetails() {
      return every(this.fieldsVisibility, value => value);
    }
  }),
  async mounted() {
    if (this.listId !== null && !this.creating) {
      this.loading = true;
      await this.LOAD_CURRENT_LIST({
        listId: this.listId
      }).then(() => {
        this.loading = false;
        switch (this.addingContacts) {
          case "import":
            this.handleImportContacts();
            break;
          case "add":
            this.handleAddManually();
            break;
        }
      });
    }
    this.listToEdit = this.currentList;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("MarketingStore", [CREATE_NEW_LIST, RESET_CURRENT_LIST, LOAD_CURRENT_LIST, UPDATE_LIST, DELETE_CURRENT_LIST, EXPORT_LIST_CONTACTS, DELETE_ALL_LIST_CONTACTS, UPDATE_CURRENT_LIST])), {}, {
    async handleSubmit() {
      if (this.creating) await this.createList();else await this.editList();
      this.changeFieldsVisibility(true);
      this.importContacts = this.creating;
    },
    async createList() {
      try {
        this.creatingList.loading = true;
        const {
          listId
        } = await this.CREATE_NEW_LIST();
        this.creatingList.status = true;
        showToast("success", "listCreated");
        this.$router.replace({
          path: this.afterCreatePath(listId)
        });
      } catch (e) {
        this.creatingList.status = false;
      } finally {
        this.creatingList.loading = false;
      }
    },
    async editList() {
      try {
        this.updatingList.loading = true;
        await this.UPDATE_LIST({
          listId: this.listId,
          data: this.currentList
        });
        this.updatingList.status = true;
        showToast("success", "listUpdated");
        this.$router.replace({
          path: this.afterCreatePath(this.listId)
        });
      } catch (e) {
        Err.handle(e);
        this.updatingList.status = false;
      } finally {
        this.updatingList.loading = false;
      }
    },
    async deleteList(modalRef) {
      try {
        this.deletingList.loading = true;
        await this.DELETE_CURRENT_LIST(this.listId);
        this.deletingList.status = true;
        this.$router.replace({
          path: "/marketing/lists"
        });
        modalRef.hide();
      } catch (e) {
        this.deletingList.status = false;
      } finally {
        this.deletingList.loading = false;
      }
    },
    handleChange(list) {
      this.UPDATE_CURRENT_LIST(list);
      this.listToEdit = list;
    },
    changeFieldsVisibility(value) {
      this.fieldsVisibility = mapValues(this.fieldsVisibility, () => value);
    },
    showImportContacts() {
      this.importContacts = true;
    },
    handleImportContacts() {
      this.manually = false;
      this.changeFieldsVisibility(false);
      this.showImportContacts();
    },
    handleAddManually() {
      this.manually = true;
      this.changeFieldsVisibility(false);
      this.showImportContacts();
    },
    afterCreatePath(listId) {
      const backPath = new _URLSearchParams(location.hash.split("?")[1]).get("backPath");
      return backPath ? unescape(backPath) : `/marketing/lists/${listId}/contacts`;
    },
    viewContacts() {
      this.$router.replace({
        path: `/marketing/lists/${this.listId}/contacts`
      });
    },
    exportContacts() {
      this.EXPORT_LIST_CONTACTS({
        listId: this.listId
      });
    },
    async deleteContacts() {
      try {
        this.deletingAllContacts.loading = true;
        await this.DELETE_ALL_LIST_CONTACTS(this.listId);
        this.deletingAllContacts.status = true;
        $("#delete-contacts-modal").modal("hide");
        this.viewContacts();
      } catch (e) {
        this.deletingAllContacts.status = false;
      } finally {
        this.deletingAllContacts.loading = false;
      }
    }
  })
});